module.exports = __webpack_public_path__ + "static/img/index_item04.740ca22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_item04.png
// module id = Z006
// module chunks = 0